import {flowchartNodeType, flowchartColumnType, flowchartStepCssName, constAddEditFlowChartStep} from '../../../util/uiconstants';

export const getFlow = (instanceRef, isPreview = false) => {
	if (instanceRef?.current) {
		const flow = instanceRef.current.toObject();
		delete flow.viewport;
		if (isPreview) {
			return flow;
		}
		const newNodes = flow.nodes.map((node) => {
			if (node.type !== flowchartNodeType.flowChartColumn) {
				return {
					id: node.id,
					type: node.type,
					data: {
						title: node.data?.title,
						description: node.data?.description,
						attachments: node.data?.attachments
					},
					position: node.position,
					parentId: node.parentId
				};
			} else {
				return {
					id: node.id,
					type: node.type,
					data: {
						title: node.data?.title
					},
					position: node.position
				};
			}
		});
		flow.edges.forEach((edge) => {
			delete edge.markerEnd;
		});
		return {nodes: newNodes, edges: flow.edges};
	}
};

// Just need to check with businees for column values.
const getCssClassName = (columnNumber) => {
	switch (columnNumber) {
		case 1:
			return 'column-1';
		case 2:
			return 'column-2';
		case 3:
			return 'column-3';
		case 4:
			return 'column-4';
	}
};

export const getCssClassNameForFlowChartSteps = (parentNode) => {
	let flowChartStepCssName = '';
	if (parentNode) {
		switch (parentNode.data.title) {
			case flowchartColumnType.initiating:
			case flowchartColumnType.initiation:
				flowChartStepCssName = flowchartStepCssName.initiating;
				break;
			case flowchartColumnType.processing:
				flowChartStepCssName = flowchartStepCssName.processing;
				break;
			case flowchartColumnType.recording:
				flowChartStepCssName = flowchartStepCssName.recording;
				break;
			case flowchartColumnType.reporting:
				flowChartStepCssName = flowchartStepCssName.reporting;
				break;
		}
	}

	return flowChartStepCssName;
};

export const setUp = (flow) => {
	let columnNumber = 1;
	flow.nodes.forEach((node) => {
		if (node.type === flowchartNodeType.flowChartColumn) {
			node.style = {
				width: 780,
				height: 1000
			};
			node.draggable = false;
			node.deletable = false;
			node.selectable = false;
			node.data.name = getCssClassName(columnNumber);
			if (columnNumber === 4) {
				columnNumber = 1;
			} else {
				columnNumber++;
			}
		}
	});

	return flow;
};

export const createStepNode = (node, flowChartColumn) => {
	let flowChartStepAttributeJson = JSON.parse(node.attributeJson);
	let parentNode = flowChartColumn.find((column) => column.id === node.columnGuid);
	var flowchartStep = {
		flowchartStepId: node.id,
		id: node.flowchartStepGuid,
		type: flowchartNodeType.flowChartStep,
		data: {
			title: node.flowchartStepName,
			description: node.flowchartStepDescription,
			name: getCssClassNameForFlowChartSteps(parentNode),
			stepRelatedObjects: {
				flowchartStepsWCGWCount: node.flowchartStepsWCGW.length,
				flowchartStepsControlCount: node.flowchartStepsControl.length,
				flowchartStepsITAppCount: node.flowchartStepsITApplication.length,
				flowchartStepsSoCount: node.flowchartStepsSO.length,
				flowchartStepsDocumentCount: node.flowchartStepsDocument.length
			},
		},
		position: {
			x: flowChartStepAttributeJson.x,
			y: flowChartStepAttributeJson.y
		},
		parentId: node.columnGuid,
		parentXPosition: parentNode.position.x,
	};
	return flowchartStep;
};

export const getChartData = (flowChart) => {
  let flowChartData = {
    nodes: [],
    //edges:[]
  };
  if (flowChart && flowChart.data && flowChart.data.length > 0) {
    let columnNodes = flowChart.data[0].attributeJson;

		let flowChartColumn = JSON.parse(columnNodes);
		flowChartColumn.forEach((node) => {
			flowChartData.nodes.push(node);
		});

		let flowchartStepNodes = flowChart.data[0].flowchartSteps;
		flowchartStepNodes.forEach((node) => {
			flowChartData.nodes.push(createStepNode(node, flowChartColumn));
		});

		return setUp(flowChartData);
	}
	return null;
};

export function getSortedNodes(data) {
	if (!_.isEmpty(data)) {
		const allNodes = data.nodes.filter((node) => node.type === flowchartNodeType.flowChartStep);
		const sortedNodes = _.sortBy(allNodes, [constAddEditFlowChartStep.ParentXPosition, constAddEditFlowChartStep.PositionY, constAddEditFlowChartStep.PositionX]);
		return sortedNodes;
	}
	return null;
}